export const environment = {
  production: false,
  apiURL: 'https://api.finappli.fr'
};
